
import {of as observableOf, Observable} from 'rxjs';
import {AbstractExecutionStep} from '../../../../../core/executor/abstract-execution-step';
import {ExecutionStepStatus} from '../../../../../core/executor/execution-step-status';

export class OpenAddressPhoneWindowExecutionStep extends AbstractExecutionStep {

  doExecute(): Observable<ExecutionStepStatus> {
    const payload = this.getPayload(),
      entity = payload.getValue().entity;

    if (!entity) {
      return this.getFailObservable('You need to pass entity as part of Payload value!');
    }

    return this.doOpen(entity);
  }

  private doOpen(entity: {
    phoneCountryCode: string,
    phoneAreaCode: string,
    phoneNumber: string,
    phoneExtension: string
  }): Observable<ExecutionStepStatus> {
    const phoneCountryCode = entity.phoneCountryCode || '',
      phoneAreaCode = entity.phoneAreaCode || '',
      phoneNumber = entity.phoneNumber || '',
      phoneExtension = entity.phoneExtension || '';

    const fullNumber = phoneCountryCode +
      phoneAreaCode +
      phoneNumber +
      phoneExtension;

    document.location.href = `tel:${fullNumber}`;

    return observableOf({status: true, content: null});
  }
}
